// Eigenbau: Modell-Dropdown für Metarr — macht die verfügbaren Modelle der
// gewählten KI-Verbindung als Dropdown auswählbar statt Freitext mit
// datalist-Vorschlägen (datalist erlaubt Tippfehler, die erst beim Lauf
// scheitern). Ein gespeichertes Modell, das nicht mehr in der Liste steht,
// bleibt als Option erhalten und ist als „(gespeichert)“ gekennzeichnet.

type ModellAuswahlProps = {
  /** Die vom Server gelieferte Modellliste der gewählten Verbindung. */
  modelle: string[];
  /** Aktuell gewählter Modellname. */
  wert: string;
  onChange: (modell: string) => void;
  id?: string;
  disabled?: boolean;
  ariaLabel?: string;
  testId?: string;
  className?: string;
};

export function ModellAuswahl({
  modelle,
  wert,
  onChange,
  id,
  disabled,
  ariaLabel,
  testId,
  className = "",
}: ModellAuswahlProps) {
  const inListe = modelle.includes(wert);
  const optionen = [...new Set([wert, ...modelle])].filter(Boolean);

  return (
    <select
      id={id}
      value={wert}
      onChange={(ereignis) => onChange(ereignis.target.value)}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      className={`w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-xs outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-800 dark:bg-gray-925 dark:text-gray-50 dark:focus:border-blue-500 dark:focus:ring-blue-950 dark:disabled:bg-gray-800 ${className}`}
    >
      {optionen.length === 0 ? (
        <option value="">Kein Modell verfügbar</option>
      ) : (
        optionen.map((modell) => (
          <option key={modell} value={modell}>
            {modell}
            {!inListe && modell === wert ? " (gespeichert)" : ""}
          </option>
        ))
      )}
    </select>
  );
}
